<template>
  <div class="specs-info">
    <ul class="specs-list">
      <li>
        <h4>Product:</h4>
        <span>{{ file.productSpecs.title }}</span>
      </li>
      <li v-for="(specs, name) in summary" :key="name">
        <h4>{{ name }}</h4>
        <ul class="sub">
          <template v-if="specs && specs.__requiredMissing">
            <li
              class="required-missing error-text"
              @click="$router.push({ name: 'printOrder' })"
            >
              Dit veld is verplicht
            </li>
          </template>
          <template v-else-if="Array.isArray(specs) && specs.length > 0">
            <li v-for="spec in specs" :key="spec">
              {{ spec }}
            </li>
          </template>
          <template v-else-if="specs != null && specs != ''">
            <li>{{ specs }}</li>
          </template>
        </ul>
      </li>
      <li class="edit" v-if="editable">
        <button class="edit-btn" @click="edit(file)">Aanpassen</button>
      </li>
    </ul>
  </div>
</template>

<script>
import { useFileListStore } from '@/stores/FileList.store'
import { useProductOrderStore } from '@/features/productOrder/ProductOrder.store'
import { mapStores } from 'pinia'

export default {
  name: 'FileInfo',
  props: ['file', 'editable'],
  computed: {
    ...mapStores(useFileListStore, useProductOrderStore),
    summary() {
      const summary = {}
      const specs = this.file?.productSpecs?.specs
      if (!specs) {
        return
      }

      if (this.file?.productSpecs?.userTemplate) {
        for (const key in specs) {
          if (
            specs[key] === '' ||
            specs[key] == null ||
            (specs[key][0] == '' && specs[key].length === 1)
          ) {
            continue
          }

          if (specs.length === 0) {
            continue
          }

          summary[key] = specs[key]
        }
      } else {
        const product = this.productOrderStore?.products?.find(
          (p) => p.title === this.file?.productSpecs?.title
        )
        const requiredOptionGroupNames = new Set()
        if (product) {
          for (const menu of product.menus || []) {
            for (const og of menu.optionGroups || []) {
              if (og.required) requiredOptionGroupNames.add(og.name)
            }
          }
        }

        for (let i = 0; i < specs.length; i++) {
          // Show required specs even when empty
          if (specs[i].optionTitle === '' || specs[i].optionName === 'NONE') {
            if (requiredOptionGroupNames.has(specs[i].optionGroupName)) {
              summary[specs[i].title] = { __requiredMissing: true }
            }
            continue
          }

          // Skip hidden specs (from hidden menus)
          if (specs[i].hidden) {
            continue
          }

          // Skip toggleOptions (enabled shows detail specs separately, disabled is not relevant)
          if (specs[i].optionGroupName === 'toggleOptions') {
            continue
          }

          // Skip buttons specs
          if (specs[i].optionGroupName === 'buttons') {
            continue
          }

          // Handle specs with fileTypeRequired
          if (specs[i].fileTypeRequired) {
            const requiredFile = this.file.productSpecs.files?.find(
              (file) => file.type === specs[i].fileTypeRequired
            )
            if (!requiredFile) {
              continue
            }
          }

          let title = specs[i].title

          if (!summary[title]) {
            summary[title] = []
          }

          summary[title].push(specs[i].optionTitle)
        }
      }

      // Add files to summary if present
      const files = this.file?.productSpecs?.files
      if (files && files.length > 0) {
        summary['Bestanden'] = files.map((file) => file.name)
      }

      return summary
    }
  },
  methods: {
    edit(file) {
      this.fileListStore.updateFileSpec([file.fileName], 'inCart', false)

      this.$router.push({
        name: 'productOrder',
        params: { toSelect: file }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.specs-list {
  display: flex;
  width: 100%;
  padding-bottom: 20px;
  flex-wrap: wrap;

  > li {
    flex-basis: 145px;
    padding-right: 15px;
    padding-bottom: 5px;
  }

  h4 {
    font-weight: 600;
    padding-bottom: 3px;
  }

  .edit {
    padding-bottom: 0;
  }
}

li.edit {
  margin-left: auto;
  flex: 0 0 116px;
  padding-right: 0;
  align-self: flex-end;
}

.sub {
  line-height: 22px;
}

.required-missing {
  cursor: pointer;
}

.edit-btn {
  background-color: var(--arch-color);
  font-size: 13.12px;
  font-weight: 500;
  width: 116px;
  height: 25px;
  border-radius: 25px;
  color: var(--arch-text-color);

  &:hover {
    box-shadow: var(--default-shadow);
    transition: box-shadow 0.3s;
  }
}
</style>
